export default __webpack_public_path__ + "static/media/icon-loaction-pin-black.1bbbd546.svg";